import { AxiosError } from 'axios';

const isAxiosError = (e: any): e is AxiosError<unknown> => e.isAxiosError as boolean;

export default isAxiosError;
